import { useEffect, useRef, useCallback } from "react";

export const useQuestStatusUpdater = (questListData, refetchCallback) => {
  const timersRef = useRef(new Map());
  const intervalRef = useRef(null);
  const isActiveRef = useRef(true);

  const cleanup = useCallback(() => {
    const currentTimers = timersRef.current;
    const currentInterval = intervalRef.current;

    currentTimers.forEach((timer) => clearTimeout(timer));
    currentTimers.clear();

    if (currentInterval) {
      clearInterval(currentInterval);
      intervalRef.current = null;
    }
  }, []);

  const forceRefetch = useCallback(async () => {
    if (!isActiveRef.current) return;

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      if (isActiveRef.current) {
        refetchCallback();

        setTimeout(() => {
          if (isActiveRef.current) {
            refetchCallback();
          }
        }, 3000);
      }
    } catch (error) {
      console.error("Error in forceRefetch:", error);
    }
  }, [refetchCallback]);

  useEffect(() => {
    if (!questListData?.data || !isActiveRef.current) return;

    cleanup();

    let hasActiveTimers = false;
    const now = new Date();

    questListData.data.forEach((locationData) => {
      locationData.quests?.forEach((quest) => {
        if (quest.participants && quest.participants.length > 0) {
          const participant = quest.participants[0];

          if (participant.expired_at && quest.consumer_status === "pause") {
            const expiredTime = new Date(participant.expired_at);
            const timeLeft = expiredTime - now;

            if (timeLeft > 0) {
              hasActiveTimers = true;

              const timer = setTimeout(() => {
                forceRefetch();
              }, timeLeft);

              timersRef.current.set(quest.id, timer);
            } else if (timeLeft <= 0) {
              forceRefetch();
            }
          }
        }
      });
    });

    if (hasActiveTimers) {
      intervalRef.current = setInterval(() => {
        if (isActiveRef.current) {
          refetchCallback();
        }
      }, 15000);
    }

    return () => {
      cleanup();
    };
  }, [questListData, refetchCallback, cleanup, forceRefetch]);

  // Cleanup khi component unmount
  useEffect(() => {
    return () => {
      isActiveRef.current = false;
      cleanup();
    };
  }, [cleanup]);
};
